
/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.hasOwnProperty('boostSDAppConfig')) {
  window.boostSDAppConfig.generalSettings.rtl = false;
  window.boostSDAppConfig.integration = Object.assign({
      wishlists: 'growave'
  }, window.boostSDAppConfig.integration || {});

}

if (typeof boost_sd_customize === 'undefined') {
const boost_sd_customize = {
  updateProductItem: (componentRegistry) => {
    /*Start Customize*/
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Add info product item',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          try {
            let productData =
              element.getParams()?.props?.product ||
              element.getParams()?.props?.productData ||
              element.getParams()?.props?.data;
            let productItem = document.querySelector('.boost-sd__product-item[id="' + productData.id + '"]');
            if (!productItem) return;
            if (productData.hasOwnProperty('variant_id')) {
              let colorBase = productData.title.split(' - ')[1];
              let availbleVariants = productData.variants.filter(
                (variant) => parseFloat(variant.price) > 0 && variant.available && variant.merged_options.includes('color:' + colorBase)
              ).sort((a,b) => parseFloat(a.price) - parseFloat(b.price));
              let variantDisplayItem = document.querySelector('.boost-sd__product-item[id="' + productData.id + '"][data-product-id="' + productData.variant_id + '"]');
              if (availbleVariants.length > 0) {
                Array.from(variantDisplayItem.querySelectorAll('a.boost-sd__product-link')).forEach(link => {
                  link.setAttribute("href",'/products/' + productData.handle + '?variant=' + availbleVariants[0].id );
                })
              } else {
                let oosVariants = productData.variants.filter(
                  (variant) => parseFloat(variant.price) > 0 && variant.merged_options.includes('color:' + colorBase)
                ).sort((a,b) => parseFloat(a.price) - parseFloat(b.price));
                Array.from(variantDisplayItem.querySelectorAll('a.boost-sd__product-link')).forEach(link => {
                  link.setAttribute("href",'/products/' + productData.handle + '?variant=' + oosVariants[0].id );
                })
              }
            }

            console.log(productData.compare_at_price_min)


          } catch (e) {}
        },
      }),
    });
    componentRegistry.useModulePlugin('FilterAPI', {
      name: 'Extra params filter in collection page',
      apply(builder) {
        // filter on collection page
        builder.on('beforeMethodCall', 'get', (payload) => {
          // TODO: do something - ts
          // example add pf_t_tag
          payload.args[0].h_options = payload.args[0].h_options
            ? payload.args[0].h_options.concat('priceless')
            : ['priceless'];
        });
      },
    });
    componentRegistry.useModulePlugin('SearchAPI', {
      name: 'Extra params filter in Search page',
      apply(builder) {
        // filter on search page
        builder.on('beforeMethodCall', 'searchInCollection', (payload) => {
          const filterParams = payload.args[0];
          if (!filterParams) return;
          // TODO: do something - ts
          payload.args[0].h_options = payload.args[0].h_options
            ? payload.args[0].h_options.concat('priceless')
            : ['priceless'];
        });
        // param on ISW
        builder.on('beforeMethodCall', 'get', (payload) => {
          if (!payload.args[2]) {
            payload.args[2] = {};
          }
          payload.args[2].h_options = payload.args[2].h_options
            ? payload.args[2].h_options.concat('priceless')
            : ['priceless'];
        });
      },
    });
    /*End Customize*/
  },
  updateCollectionTitle: (componentRegistry) => {
    componentRegistry.useComponentPlugin('HeaderTitle', {
      name: 'update collection title',
      apply: () => {

       return {
          afterRender(element) {
             try {
               let hasUpdated = false; // Prevent rendering twice
                const collectionTitleEle = element.getRootElm();
                  if (collectionTitleEle && !hasUpdated) {
                     hasUpdated = true;
                     collectionTitleEle.innerHTML = collectionTitle

                  }
             } catch (err) {
                console.warn(err);
             }
          }
       }
      }
    });
  },

  translateCollectionTitle: (componentRegistry) => {
    componentRegistry.useComponentPlugin('CollectionHeader', {
          name: 'Custom CollectionHeader #233513',
          enabled: true,
          apply: () => ({
            afterRender(element) {
              try {
                // Start customization--------------------------------------------
                let currentCollectionUrl = window.location.href + '.json';
                jQuery.get(currentCollectionUrl, function(data, status){
                  let currentCollectionTitle = data.collection.title;
                  jQuery('.boost-sd__header-title').html(currentCollectionTitle);
                });
              } catch (e) {
                console.error(e);
              }
            }
          })
      });
  }
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  boost_sd_customize.updateProductItem,
  boost_sd_customize.updateCollectionTitle,
  boost_sd_customize.translateCollectionTitle
]);
}